import React from 'react';
import PropTypes from 'prop-types';

const ErrorFieldMessage = ({ field }) =>
  <div className="error-field">
    {field.meta.touched &&
      field.meta.error &&
      <div className="help-block">
        {field.meta.error}.
      </div>}
  </div>;

ErrorFieldMessage.propTypes = {
  field: PropTypes.object.isRequired
};

ErrorFieldMessage.defaultProps = {
  field: { meta: {} }
};

export default ErrorFieldMessage;
